<template>
  <div class="sa-lab-profile">
    <div class="sa-d-flex">
      <figure class="sa-avt-img">
        <img src="https://img.litedev.com/images/unknown-avtar.png" alt="Doctor" class="sa-img-cover" />
      </figure>
      <div>
        <span>Welcome back,</span>
        <h6 v-if="userInfo">{{ userInfo.title_nm }} {{ userInfo.fn }} {{ userInfo.ln }}
          <!-- <span class="sa-ml10"><i class="icon-checked2 sa-mr5"></i>verified</span> -->
        </h6>
      </div>
    </div>
    <span class="sa-notification" @click="$router.push('/notification')">
      <i class="icon-ring"></i>
      <span>{{notificationCount}}</span>
    </span>
    <!-- <div class="sa-publish-pr">
      <span> <i class="i-icon">i</i>Publish your profile </span>
      <div class="sa-d-f-a-center">
        <span>Disable me</span>
        <div class="sa-switch">
          <input type="checkbox" id="notific" name="notific" /><label
            for="notific"
            ><span class="sa-input-box"></span
          ></label>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: null,
    };
  },
  computed: {
    notificationCount: function () {
      return this.$store.getters.getNotificationCount
    }
  },
  mounted() {
    this.userInfo = JSON.parse(this.$localStorage.get("userdata"));
  },
};
</script>
